module.exports = __webpack_public_path__ + "img/verified.49872e3e.svg";